import * as React from "react";
import './Pick.css';
import '../components/Typograph.css';
import AppHeader from '../components/AppHeader';
import AppFooter from "../components/AppFooter";
import ImageRadioPicker from "../components/ImageRadioPicker";
import {MontageType} from "../Model";
import muurMontageImage from '../images/muurmontage.jpg'
import kozijnMontageImage from '../images/kozijnmontage.jpg'

export default class MountingPick extends React.Component {
   render() {
        return (
            <div className="page">
                <AppHeader title="Montage type"/>

                <div className="page-middle">
                    <h1 className="pick-title">Welk montage type is van toepassing?</h1>

                    <div className="pick-body">
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={MontageType.MUUR}
                                          image={muurMontageImage}/>

                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={MontageType.KOZIJN}
                                          image={kozijnMontageImage}/>
                    </div>
                    <p className="detail-warning-text" hidden={this.props.currentValue !== MontageType.KOZIJN}>
                        De keuzehulp kan u helaas nog niet helpen met kozijnmontage.
                        <br/><br/>
                        Wanneer u kozijnmontage wilt toepassen, kunt u gebruik maken van de <a href="/help/offerte-aanvraag">offerte aanvraag</a>.
                    </p>
                </div>
                <AppFooter onNext={this.props.handleNextPage}
                           onPrevious={this.props.handlePreviousPage}
                           enableNext={this.props.currentValue === MontageType.MUUR}/>
            </div>
        );
    }
}
